import { render, staticRenderFns } from "./SetFree.vue?vue&type=template&id=fab3adbc&scoped=true&"
import script from "./SetFree.vue?vue&type=script&lang=js&"
export * from "./SetFree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab3adbc",
  null
  
)

export default component.exports